import { OnInit, OnDestroy } from '@angular/core';
import { SidebarService } from '@ibe/services/ui';
import { Router, ActivatedRoute } from '@angular/router';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import { TRANSLATION_ANCILLARY_DETAILED, ANCILLARY_GROUP_HAND_BAGGAGE_LIST, TRANSLATION_ANCILLARY_GROUP, ANCILLARY_PRODUCT_GROUP_CODE_HAND_BAGGAGE, BRAND_DESCRIPTION_TOP_EXECUTIVE, BRAND_DESCRIPTION_EXECUTIVE, COUNTRY_VENEZUELA, COUNTRY_BRAZIL, ANCILLARY_GROUP_DEPORTEES_LIST, ANCILLARY_GROUP_MEDICAL_ASSISTANCE_LIST, SSR_CODE_UNACCOMPANIED_MINOR, COUNTRY_CODE_VENEZUELA, COUNTRY_CODE_BRAZIL, COUNTRY_CODE_USA, BRAND_NAMES_MAP, ECONOMY_CABIN_CODE, SESSION_VAR_KEY_LANGUAGE, DEFAULT_LANGUAGE, SESSION_VAR_KEY_MARKET, DEFAULT_MARKET, SPECIAL_CASE_MARKET_LANGUAGE_MAP } from '@ibe.config';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRALocationService } from "@ibe.services/location.indra.service";
import { INDRABFMDataStorageService } from "@ibe.services/bfm-data-storage.indra.service";
import { INDRAAncillariesShoppingCartService } from '@ibe.services/ancillaries-shopping-cart.indra.service';
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';
import { INDRATotalSummaryService } from '@ibe.services/total-summary.service';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
var INDRADetailsHandLuggageComponent = /** @class */ (function () {
    function INDRADetailsHandLuggageComponent(sidebarService, route, router, bookingService, ibeAdminService, locationService, bfmDataStorage, ancillaryCartService, totalSummaryService, bookingSearchService, ibeAdminConfigService) {
        this.sidebarService = sidebarService;
        this.route = route;
        this.router = router;
        this.bookingService = bookingService;
        this.ibeAdminService = ibeAdminService;
        this.locationService = locationService;
        this.bfmDataStorage = bfmDataStorage;
        this.ancillaryCartService = ancillaryCartService;
        this.totalSummaryService = totalSummaryService;
        this.bookingSearchService = bookingSearchService;
        this.ibeAdminConfigService = ibeAdminConfigService;
        this._hasEdit = false;
        this.passengers = [];
        this.paxFareInfoFeatures = [];
        this.paxPurchaseFeatures = [];
        this.LOCAL_TRANSLATION_WHATS_INCLUDED_MODULE = 'whatsIncludedSidebars.';
        this.LOCAL_TRANSLATION_DETAILED_HAND_LUGGAGE = this.LOCAL_TRANSLATION_WHATS_INCLUDED_MODULE + 'detailsHandLuggage.';
        this.hasLayover = false;
        this.countUnit = '';
        this.countryCodes = [
            COUNTRY_CODE_VENEZUELA,
            COUNTRY_CODE_BRAZIL,
            COUNTRY_CODE_USA
        ];
        this.isVenezuela = false;
        this.isBrazil = false;
        this.isUsa = false;
        this.isEconomyFlight = false;
        this.hasDeporteeFlag = false; // this will be utilized for detecting deportee/under lawful custody ancillary on prm
        this.hasMedicalAssistanceFlag = false; // this will be utilized for detecting requested medical assistance on prm
        this.hasUMNRFlag = false; // this will be utilized for detecting if unaccompnied minor SSR was included on prm
        this.hasWarning = false; // this will be a flag for displaying warning messages on the sidebar
        this.IfAllPassengersAreChildren = false;
        this.hasIssuedTicket = true; // used for checking if PNR has issued ticket/s
        this.isFlagged = false;
        this.isBookingView = false;
        this.isReviewTTTCompletion = false;
        if (this.router.url.includes('/my-bookings/view/'))
            this.isBookingView = true;
        if (this.router.url.includes('/review-your-trip/deeplink/'))
            this.isReviewTTTCompletion = true;
    }
    INDRADetailsHandLuggageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.flightIdentifier = this.route.snapshot.paramMap.get('flight');
        this.flight = this.bookingService.INDRA_getBookedFlight(this.flightIdentifier);
        this.flightRouteInput = this.bookingService.INDRA_getFlightRoute(this.flight);
        this.passengers = this.bookingService.INDRA_getPaxInfo();
        this.hasLayover = this.INDRA_checkIndirectFlight();
        this.ancillaryGroup = ANCILLARY_PRODUCT_GROUP_CODE_HAND_BAGGAGE;
        this.brandDescription = this.INDRA_getBrandDescription();
        // Check if flight cabin is economy
        this.isEconomyFlight = (this.flight.cabin === 'Economy' || this.flight.cabin === ECONOMY_CABIN_CODE);
        // Checks if flight's origin/destination is a special country
        this.INDRA_checkIfSpecialCaseCountry();
        // Check if all passengers in the PNR are children
        this.IfAllPassengersAreChildren = this.bookingService.INDRA_checkIfAllPassengersAreChildren(this.passengers);
        // check if PNR has an issued ticket/s
        this.hasIssuedTicket = this.bookingService.INDRA_checkIfPNRIssuedTickets();
        var fareInfoAncillary = this.bookingService.INDRA_getPassengersAncillaryFareInformation(ANCILLARY_PRODUCT_GROUP_CODE_HAND_BAGGAGE, this.flight.idFlight.toString(), true);
        var purchasedAncillaryWithSegmentInfo = this.bookingService.INDRA_getPassengersPurchasedAncillaryWithSegmentInfo(ANCILLARY_PRODUCT_GROUP_CODE_HAND_BAGGAGE, this.flight.idFlight.toString(), this.flightIdentifier);
        this.passengers.forEach(function (pax) {
            var _a, _b, _c;
            var fareInfoindex = fareInfoAncillary.findIndex(function (object) { return object[pax.idPax]; });
            var paxfareAncillaries = fareInfoAncillary[fareInfoindex];
            _this.paxFareInfoFeatures.push((_a = {},
                _a[pax.idPax] = _this.INDRA_constructAncillaryList(paxfareAncillaries[pax.idPax]),
                _a));
            ;
            var purchasedIndex = purchasedAncillaryWithSegmentInfo.findIndex(function (object) { return object[pax.idPax]; });
            if (purchasedIndex === -1) {
                _this.paxPurchaseFeatures.push((_b = {},
                    _b[pax.idPax] = [],
                    _b));
            }
            else {
                var paxpurchasedAncillaries = purchasedAncillaryWithSegmentInfo[purchasedIndex];
                _this.paxPurchaseFeatures.push((_c = {},
                    _c[pax.idPax] = _this.INDRA_constructAncillaryListForPurchased(paxpurchasedAncillaries[pax.idPax]),
                    _c));
                //sort ascending based on segmentID
                _this.paxPurchaseFeatures.sort(function (first, second) { return (Number(first.segmentId) > Number(second.segmentId) ? -1 : 1); });
            }
            if (pax.prm) {
                var deporteePRM = pax.prm.filter(function (prmItem) { return ANCILLARY_GROUP_DEPORTEES_LIST.includes(prmItem.type); });
                var medicalAssistancePRM = pax.prm.filter(function (prmItem) { return ANCILLARY_GROUP_MEDICAL_ASSISTANCE_LIST.includes(prmItem.type); });
                var umnrPRM = pax.prm.filter(function (prmItem) { return SSR_CODE_UNACCOMPANIED_MINOR == prmItem.type; });
                if (deporteePRM.length > 0) {
                    _this.hasDeporteeFlag = true;
                }
                if (medicalAssistancePRM.length > 0) {
                    _this.hasMedicalAssistanceFlag = true;
                }
                if (umnrPRM.length > 0) {
                    _this.hasUMNRFlag = true;
                }
            }
        });
        this.totalSummarySubscription = this.totalSummaryService.INDRA_getObservableTotalSummary().subscribe(function (data) {
            if (data) {
                _this.isFlagged = _this.bookingService.INDRA_isUnavailableFlight(_this.flight.idFlight, data);
            }
        });
    };
    INDRADetailsHandLuggageComponent.prototype.INDRA_gotoURL = function (key) {
        var languageCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
            sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase() : DEFAULT_LANGUAGE;
        var languageMap = SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] ? SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] : languageCode;
        var marketCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
            sessionStorage.getItem(SESSION_VAR_KEY_MARKET).toLowerCase() : DEFAULT_MARKET;
        var urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
        var urlNavigate = urlIbeAdmin.replace('${lang}', "" + languageMap).replace('${market}', "" + marketCode);
        return window.open(urlNavigate);
    };
    INDRADetailsHandLuggageComponent.prototype.INDRA_constructAncillaryList = function (list) {
        var _this = this;
        var returnValue = '';
        if (list.length > 0) {
            list.forEach(function (item) {
                if (returnValue.length === 0) {
                    returnValue = _this.INDRA_getTranslation("" + (TRANSLATION_ANCILLARY_DETAILED + item));
                }
                else {
                    returnValue = returnValue + ', ' + _this.INDRA_getTranslation("" + (TRANSLATION_ANCILLARY_DETAILED + item));
                }
            });
        }
        else {
            returnValue = '';
        }
        return returnValue;
    };
    INDRADetailsHandLuggageComponent.prototype.INDRA_constructAncillaryListForPurchased = function (list) {
        var _this = this;
        var returnValue = [];
        list.forEach(function (segment) {
            // flag for unconfirmed codes
            var unconfirmed = false;
            var descriptionForSegment = '';
            segment.ancillaryList.forEach(function (ancillary) {
                if (descriptionForSegment.length === 0) {
                    descriptionForSegment = _this.INDRA_getTranslation("" + (TRANSLATION_ANCILLARY_DETAILED + ancillary.code));
                }
                else {
                    descriptionForSegment = descriptionForSegment + ', ' + _this.INDRA_getTranslation("" + (TRANSLATION_ANCILLARY_DETAILED + ancillary.code));
                }
                // ANCILLARIES WARNING
                if (ancillary.unconfirmed) {
                    unconfirmed = true;
                    _this.hasWarning = true;
                }
            });
            returnValue.push({
                ancillaryDetail: descriptionForSegment,
                segmentId: segment.segmentId,
                // ANCILLARIES WARNING
                unconfirmed: unconfirmed
            });
        });
        return returnValue;
    };
    INDRADetailsHandLuggageComponent.prototype.INDRA_displaySegmentInfo = function (segmentId) {
        var returnValue = '';
        if (this.hasLayover) {
            var segmentInfo = this.bookingService.INDRA_getSegment(this.flightIdentifier, segmentId);
            var segmentDeparture = this.bookingService.INDRA_getLocation(segmentInfo.departureAirport);
            var segmentArrival = this.bookingService.INDRA_getLocation(segmentInfo.arrivalAirport);
            returnValue = ' ' + segmentDeparture.city + ' - ' + segmentArrival.city;
        }
        return returnValue;
    };
    INDRADetailsHandLuggageComponent.prototype.INDRA_getTranslation = function (key) {
        return this.ibeAdminService.getTranslationValue(key);
    };
    INDRADetailsHandLuggageComponent.prototype.INDRA_getAncillaryForPassenger = function (list, idPax) {
        var returnValue;
        var index = list.findIndex(function (item) { return Object.keys(item)[0] === idPax.toString(); });
        if (list) {
            var paxAncillary = list[index];
            returnValue = paxAncillary[idPax];
            if (returnValue) {
                returnValue += this.INDRA_getTranslation('whatsIncludedSidebars.detailsHandLuggage.text.personalItemInclusion');
            }
            return returnValue;
        }
    };
    INDRADetailsHandLuggageComponent.prototype.INDRA_getPurchasedAncillaryForPassenger = function (idPax) {
        var returnValue = [];
        var index = this.paxPurchaseFeatures.findIndex(function (item) { return Object.keys(item)[0] === idPax.toString(); });
        if (this.paxPurchaseFeatures) {
            var paxAncillary = this.paxPurchaseFeatures[index];
            returnValue = paxAncillary[idPax];
            return returnValue;
        }
    };
    INDRADetailsHandLuggageComponent.prototype.INDRA_printPassengerName = function (pax) {
        return this.INDRA_capitalize(pax.name) + ' ' + this.INDRA_capitalize(pax.surname);
    };
    INDRADetailsHandLuggageComponent.prototype.INDRA_capitalize = function (str) {
        if (str.length > 0) {
            return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        }
        return '';
    };
    INDRADetailsHandLuggageComponent.prototype.INDRA_printBrand = function () {
        return this.brandDescription;
    };
    INDRADetailsHandLuggageComponent.prototype.INDRA_getGroupLabel = function () {
        var groupList = ANCILLARY_GROUP_HAND_BAGGAGE_LIST;
        return this.INDRA_getTranslation("" + (TRANSLATION_ANCILLARY_GROUP + groupList[0]));
    };
    // SIDEBAR INTERACTIONS
    /** Close sidebar and clear secondary route */
    INDRADetailsHandLuggageComponent.prototype.closeSidebar = function () {
        this.sidebarService.closeSidebar();
        this.router.navigate([{ outlets: { sidebar: null } }], { replaceUrl: true });
    };
    /** Handles close action intention **/
    INDRADetailsHandLuggageComponent.prototype.INDRA_handleClose = function () { this.closeSidebar(); };
    INDRADetailsHandLuggageComponent.prototype.INDRA_getTitleTranslation = function (lastKey, keyType) {
        var key = this.LOCAL_TRANSLATION_DETAILED_HAND_LUGGAGE + keyType + "." + lastKey;
        return this.INDRA_getTranslation(key);
    };
    INDRADetailsHandLuggageComponent.prototype.INDRA_showUpgrade = function () {
        // let brand = this.INDRA_printBrand();
        return !(this.brandDescription === BRAND_DESCRIPTION_TOP_EXECUTIVE || this.brandDescription === BRAND_DESCRIPTION_EXECUTIVE || this.hasDeporteeFlag || this.hasMedicalAssistanceFlag || this.hasUMNRFlag || this.IfAllPassengersAreChildren || !this.hasIssuedTicket) && !this.isFlagged;
    };
    INDRADetailsHandLuggageComponent.prototype.INDRA_getTranslationKey = function (lastKey, keyType) {
        return this.LOCAL_TRANSLATION_DETAILED_HAND_LUGGAGE + keyType + "." + lastKey;
    };
    /**
     *  Returns a specific weight limitation translation key depending
     * 	on cabin and destination/origin involved.
     */
    INDRADetailsHandLuggageComponent.prototype.INDRA_getHandBagSpecificWeightLimitTranslationKey = function (lastKey, keyType) {
        /**
            if economy:
                venezuela or brazil: up to 10 kg
                all others: up to 8 kg
            if business:
                all: up to 8 kg
        */
        var countrySuffix = '';
        if (this.flight && this.isEconomyFlight) {
            countrySuffix = this.isVenezuela ? COUNTRY_VENEZUELA : countrySuffix;
            countrySuffix = this.isBrazil ? COUNTRY_BRAZIL : countrySuffix;
            return this.LOCAL_TRANSLATION_DETAILED_HAND_LUGGAGE + keyType + "." + lastKey + countrySuffix;
        }
        else {
            return this.LOCAL_TRANSLATION_DETAILED_HAND_LUGGAGE + keyType + "." + lastKey;
        }
    };
    INDRADetailsHandLuggageComponent.prototype.INDRA_checkIndirectFlight = function () {
        var segments = this.bookingService.INDRA_getSegmentIDs(this.flightIdentifier);
        var flag = false;
        if (segments.length > 1) {
            flag = true;
        }
        return flag;
    };
    /** Returns array of countries that will be used based
     *  on countries' hand baggage rules */
    INDRADetailsHandLuggageComponent.prototype.INDRA_checkIfSpecialCaseCountry = function () {
        var activeFare = this.bfmDataStorage.INDRA_getActiveBookedTrip().data.fare;
        var flightSegments = this.bookingService.INDRA_getBoundObject(this.flight, activeFare);
        var specialCaseCountries = this.locationService.INDRA_getSpecialCaseLocation(this.countryCodes, flightSegments, this.flightIdentifier);
        this.isVenezuela = specialCaseCountries.includes(COUNTRY_CODE_VENEZUELA);
        this.isBrazil = specialCaseCountries.includes(COUNTRY_CODE_BRAZIL);
        this.isUsa = specialCaseCountries.includes(COUNTRY_CODE_USA);
    };
    INDRADetailsHandLuggageComponent.prototype.INDRA_upgradeWithCash = function () {
        var activeBookedTrip = this.bfmDataStorage.INDRA_getActiveBookedTrip();
        var link = '/my-bookings/upgrade-with-cash/' + activeBookedTrip.data.pnr;
        var params = { flight: this.flight.assignedFlightId };
        this.sidebarService.closeSidebar();
        this.bookingService.INDRA_linkRouteData(link, params);
    };
    INDRADetailsHandLuggageComponent.prototype.ngOnDestroy = function () {
        if (this.totalSummarySubscription)
            this.totalSummarySubscription.unsubscribe();
    };
    INDRADetailsHandLuggageComponent.prototype.INDRA_printImage = function () {
        var IMAGE = 'handbag-economy.jpg';
        return 'url(assets/images/ancillaries/includes/' + IMAGE + ')';
    };
    INDRADetailsHandLuggageComponent.prototype.INDRA_getBrandDescription = function () {
        if (this.isBookingView || this.isReviewTTTCompletion) {
            if (!this.flight.fareFamily)
                return '';
            var brandCode = this.bookingSearchService.INDRA_getBrandCodeFromAmadeus(this.flight.fareFamily);
            return brandCode ? BRAND_NAMES_MAP[brandCode] : '';
        }
        else {
            this.bookingService.INDRA_getBrand(this.flightIdentifier.toString());
        }
    };
    return INDRADetailsHandLuggageComponent;
}());
export { INDRADetailsHandLuggageComponent };
